module.exports = __webpack_public_path__ + "img/IMG_20191125_201100.ce78432e.jpg";